import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import useLoggedInUser from 'app/hooks/useLoggedInUser';

import { markPageSeen } from '../newlyIncludedPagesSeen';
import type { SidebarNavItem } from '../types';
import useNewlyIncludedPages from './useNewlyIncludedPages';

/**
 * Opening a newly included page clears its green dot, however the user got there: the sidebar, a
 * Home card or a link on another page. Pages in connect-v1 (Orders) clear when clicked instead.
 */
export default function useClearOpenedPageDot(navigation: SidebarNavItem[]): void {
  const userId = useLoggedInUser()?._id;
  const { pathname } = useLocation();
  const { isNewlyIncluded } = useNewlyIncludedPages();

  const openedId = navigation
    .flatMap((entry) => entry.children ?? [entry])
    .find(
      (item) =>
        item.type === 'item' &&
        item.url &&
        isNewlyIncluded(item.id) &&
        matchPath({ path: `/${item.url}`, end: false }, pathname)
    )?.id;

  useEffect(() => {
    if (userId && openedId) markPageSeen(userId, openedId);
  }, [userId, openedId]);
}
